﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Constraint } from "@models/configurators/output-fields/cad/mates/constraint";
import { eOutputFieldType } from "@models/enums";
import { ICadLibReference } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadLibReference, eOutputFieldType.cadLibReference)
export class CadLibReference extends Constraint implements ICadLibReference {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public referenceType: string;

}
